import styles from "../Document.module.css";
import templateStyles from './Templates.module.css'

import React, { useState, useCallback, useEffect } from 'react';

import { BASE_URL, USER_TOKEN } from "../../../Utils/constant";
import useRefreshToken from "../../../Hooks/usegenerateToken";
import { STATUS } from "../../../Utils/Strings";
import { _ToNormal, isInternalUser, IssuerDate } from "../../../Utils/helper";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPortalModal from "../../../components/ReactPortalModal";
import PreviewPDF from "../../../components/pdfPreview/Previewpdf";
import cogoToast from "cogo-toast-react-17-fix";

const TemplatesTable = ({ data, title, setSortBy, sortBy, get_documents, setTemplateSearch, searchText }) => {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [initialLoad, setInitialLoad] = useState(true);
    const [searchData, setsearchData] = useState([])
    const isInternal = isInternalUser()
    const [previewDocId, setpreviewDocId] = useState(false)

    useEffect(() => {
        setsearchData(data)
    }, [data])
    // search
    const [search, setSearch] = useState(null)

    const handleSearch = (e) => {
        setTemplateSearch(e)
    }
//     useEffect(()=>{
//     const handleSearchFilter = setTimeout=(() => {

//     get_documents()
//     },700)
//     return ()=>clearTimeout(handleSearchFilter)
// },[searchText])

    const location = useLocation();
    const path = location.pathname;

    const disableDoc = (id) => {
        // setLoading(true)
        // let temparr = data.filter(Doc => Doc.id == id)[0]
        // if (temparr.document_state == STATUS.ISSUED) {
        //     cogoToast.error(MESSAGE.DOCUMENT_ALREADY_ISSUED, { position: 'top-right' })

        // }
        // else {
        //     if (temparr.document_state == STATUS.ACTIVE || temparr.document_state == STATUS.INACTIVE) {
        //         API.put(UPDATE_DOCUMENT_STATUS + id)
        //             .then(data => {
        //                 // get_documents()
        //             }).finally(() => setLoading(false))
        //     }
        //     else {
        //         // cogoToast.error(`Could not activate if Status is ${_ToNormal(temparr.document_state)}`, { position: 'top-right' })
        //         cogoToast.error(MESSAGE.COULD_NOT_ACTIVATE, { position: 'top-right' })

        //     }
        // }
        // setLoading(false)
        cogoToast.info("Disabled")
    }
    const SortList=(sort)=>{
        let direction = "asc";

    if (sortBy.key === sort && sortBy.direction === "asc") {
        direction = "desc";
    }
    const newSortBy = { key:sort, direction }
        setSortBy(newSortBy)
    }

    const TableActions = useCallback(({ i }) => {
        if (loading)
            return (<div className='shimmer' style={{ height: '2.5rem' }}></div>)
        let preview = (i.document_state != STATUS.DOCUMENT_CREATED && i.document_state != STATUS.TAG_MAPPING)
        let edit = (i.editable && i.document_state != STATUS.ISSUED && i.document_state !== STATUS.INACTIVE && i.document_state !== STATUS.ACTIVE)
        return (
            <div className={styles.buttonBase}>
                {preview ?
                    <button id="pdf-preview" className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} title="Preview" onClick={() => setpreviewDocId(i.id)}>
                        <img src='/eyeoutline.svg' className={styles.editicon} />
                    </button>
                    :
                    <button className={`btn ${styles.editPencil} ${styles.disabled}`} title="Preview"><img src='/eyeoutline.svg' className={styles.editicon} /></button>
                }
                {edit ?
                    <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => navigate("/create/" + i.id + "/Mapping")} title="Edit"><img src='/EditPencil.svg' className={styles.editicon} /></button> :
                    <button className={`btn ${styles.editPencil} ${styles.disabled}`} style={{ margin: "0px 10px" }} title="Edit" ><img src='/EditPencil.svg' className={styles.editicon} /></button>
                }
                {/* {i.document_state == STATUS.ACTIVE ?
                    <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => disableDoc(i.id)} title={STATUS.DEACTIVATED}><img src='/deactivate.svg' className={styles.editicon} /></button> :
                    <button className={`btn ${styles.editPencil} ${styles.disabled}`} style={{ margin: "0px 10px" }}
                        onClick={() => disableDoc(i.id)}
                        title={i.document_state == STATUS.ISSUED ? STATUS.ISSUED : STATUS.ACTIVATED}><img src='/deactivate.svg' className={styles.editicon} /></button>
                } */}

                <ReactPortalModal title={i.doc_name + " preview"} isOpen={i.id == previewDocId} onClose={setpreviewDocId} blockOutsideClick={true}>
                    <PreviewPDF doc_id={i.id} load={loading} setLoading={setLoading} type={'pdf'} isMaster isInternal />
                </ReactPortalModal>
            </div>

        )
    }, [previewDocId])

    return (
        <>
            <section className={`${templateStyles.searchHeader} table-header6`}>
                <div>
                    {title}
                </div>
                <div className="inputField2">
                    <div className="input1">
                        <div className="content1">
                            <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                            <input value={searchText} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                        </div>
                    </div>
                </div>
            </section>
            <div style={{ overflowX: "Scroll", margin: "1rem" }}>
                {/* <Loader isOpen={loading || pdfload} /> */}
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th className={styles.th}>
                            <div style={{display:"flex", gap:"4px"}}>
                            <div>MASTER DOCUMENT</div>
                            <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("master_doc_name")}>
                                <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                            </div>
                            </div>
                            </th>
                            <th className={styles.th}>
                                <div style={{display:"flex", gap:"5px"}}>
                                <div>DOCUMENT NAME</div>
                                    <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("doc_name")}>
                                    <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                                </div>
                                </div>
                            </th>
                            <th className={styles.th}>VERSION</th>
                            <th className={styles.th}>
                                <div style={{display:"flex", gap:"5px"}}>
                                <div>LAST UPDATED ON</div>
                                <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("updated_at")}>
                                <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                            </div>
                                </div>
                            </th>
                            <th className={styles.th}>TAGS</th>
                            <th className={styles.th}>DESIGN</th>
                            <th className={styles.th}>
                                <div style={{display:"flex", gap:"6px"}}>
                                    <div>STATUS</div>
                                    <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("status")}>
                                <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                            </div>
                                </div>
                            </th>
                            <th className={styles.th}>ACTIONS</th>
                        </tr>
                    </thead>
                    {searchData.length>0 ?searchData.map((i, index) => {
                        let design = i.document_state != STATUS.TAG_MAPPING && i.document_state != STATUS.DOCUMENT_CREATED ? styles.done : styles.pending
                        let tags = i.document_state != STATUS.DOCUMENT_CREATED ? styles.done : styles.pending
                        let status = i.document_state == STATUS.ACTIVE ? styles.done : i.document_state == STATUS.ISSUED || i.document_state == STATUS.INACTIVE ? styles.inactive : styles.pending
                        return (
                            <tbody key={i.id}>
                                <tr className={`${styles.tr} ${initialLoad ? styles.fadeIn : ''}`}
                                    style={loading ? null : { animationDelay: `${index * 0.1}s` }}
                                >
                                    <td className={styles.td}>
                                        <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.master_doc_name}</div>
                                    </td>
                                    <td className={styles.td}>
                                        <div>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.doc_name}</div>
                                    </td>
                                    <td className={styles.td}>
                                        <div className={styles.time}>{loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : i.version}</div>
                                    </td>
                                    <td className={styles.td}>
                                        <div className={styles.time}>
                                            {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> : <IssuerDate dateString={i.updated_at} />}
                                        </div>
                                    </td>
                                    <td className={styles.td}>
                                        {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                                            (tags == styles.done ? <div className={tags}>{STATUS.DONE}</div> : <div className={tags}>{STATUS.PENDING}</div>)}
                                    </td>
                                    <td className={styles.td}>
                                        {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                                            (design == styles.done ? <div className={design}>{STATUS.DONE}</div> : <div className={design}>{STATUS.PENDING}</div>)}
                                    </td>
                                    <td className={styles.td}>
                                        {loading ? <div className='shimmer' style={{ height: '2.5rem' }}></div> :
                                            // (i.status == STATUS.DONE ? <div className={status}>{STATUS.ACTIVATED}</div>:  <div className={status}>{i.status || STATUS.DEACTIVATED}</div>)}
                                            <div className={status}>{_ToNormal(i.document_state)}</div>}
                                    </td>
                                    <td className={styles.td}>
                                        <TableActions i={i} />
                                    </td>
                                </tr>
                            </tbody>
                        )
                    }):
                        <tr>
                                <td colSpan="8" className={styles.tablescell} style={{ textAlign: 'center', padding: '1rem' }}>
                                  <div className="Data_List">No Template Found</div>
                                </td>
                              </tr>}
                </table>
            </div>
        </>
    )

};

export default TemplatesTable;